import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders a country's flag as a Unicode emoji, by mapping each ASCII letter of the
 * (alpha-2) country code to its Regional Indicator Symbol. Replaces the react-country-flag
 * dependency, whose default (emoji) mode did the exact same transform.
 */
export default function CountryFlag({ countryCode, className, "aria-label": ariaLabel, }) {
    const emoji = countryCode.toUpperCase().replace(/./g, (c) => String.fromCodePoint(c.codePointAt(0) + 127397));
    return (_jsx("span", { role: "img", className: className, "aria-label": ariaLabel, children: emoji }));
}
